'use client';
import { useAccountInfo } from '@/hooks/query/account';
import { MatchModelBase } from '@nf/types/odds';
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';
import { Button } from '@nf/ui';
import { CloseBigIcon } from '@/components/icons/svg-icons';
import { useStreamingStore } from '@/store/streaming';

export const GVBase = ({ match }: { match?: MatchModelBase }) => {
	const lsId = 'STATSCORE_LMP_GENERATOR_SCRIPT';
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const trackerRef = useRef<HTMLDivElement>(null);
	const checkSTATSCORE = () => {
		if (typeof window.STATSCORE == 'undefined') { 
			setTimeout(() => {
				checkSTATSCORE();
			}, 200);
		} else {
			if (!document.getElementById('tracker-1')) {
				const authToken = user?.LSportsID;
				const trackerGenerator = new window.STATSCORE.LSP.Generator({ authToken: authToken })
				trackerGenerator.create('#trak', 'tracker-1', match?.lsmid, 1198, { lang: 'en', configuration: {
					useMappedId: '1',
					mainBoxBasicRelationInitializationTab: 'Expander',
					mainBoxInitializationTab: 'Expander'
				} })
			}
		}
	}

	const [
		isStreamingFloat,
		setIsStreamingFloat,
		setStreamingType,
	] = useStreamingStore(
		state => [
			state.isStreamingFloat,
			state.setIsStreamingFloat,
			state.setStreamingType,
		]
	);

	useEffect(() => {
		if (!document.getElementById(lsId)) {
			const s = document.createElement('script');
			s.id=lsId;
			s.src='https://live.statscore.com/livescorepro/generator?auto_init=false';
			s.async=true;
			document.body.appendChild(s);
		}
		const element = document.getElementById('tracker-1');
		if (element) {
			element.remove(); // 移除原本的div
		}
		checkSTATSCORE();
	}, [match?.lsmid]);

	const handleIframeClose = () => {
		setIsStreamingFloat(false);
		setStreamingType('');
	};

	return (
		<div className="video-view video-view-ref">
			{isStreamingFloat ?
				<Button className="btn--icon btn--close" onClick={handleIframeClose}>
					<CloseBigIcon />
				</Button>
				: null}
			<div id="GVFrame" >
				<div ref={trackerRef} id="trak" style={{ width: '100%' }}></div>
			</div>
		</div>
	);
};

// export const GVBase = ({ key }: { key: string; }) => {
// 	let _tb: null;
// 	const [isScriptLoaded, setIsScriptLoaded] = useState(false);
// 	const initial = () => {
// 	};
// 	useEffect(() => {
// 		// const abcjsInit = async () => {
// 		// 	const Trailblazer = (await import(window.location.protocol + '//Gvweb.garcade.net:' + (window.location.protocol === 'https:' ? '8097' : '8096') + '/js/trailblazerlib-mobile.js')).default;
// 		// 	console.log(Trailblazer);
// 		// 	_tb = new Trailblazer();
// 		// 	_tb.gvstart();
// 		// };
// 		// abcjsInit();
// 		// const script = document.createElement('script');
// 		// script.src = window.location.protocol + '//Gvweb.garcade.net:' + (window.location.protocol === 'https:' ? '8097' : '8096') + '/js/trailblazerlib-mobile.js';
// 		// script.onload = () => {
// 		// 	setIsScriptLoaded(true);
// 		// 	console.log(_tb);
// 		// 	if (_tb===null) {
// 		// 		_tb = window.Trailblazer()
// 		// 		_tb.setUserLang();
// 		// 		console.log('trailblazerlib-mobile.js loaded successfully.');
// 		// 	}
// 		// };
// 		// document.body.appendChild(script);
// 		// return () => {
// 		// 	// 組件卸載時移除腳本
// 		// 	document.body.removeChild(script);
// 		// };
// 	}, []);

// 	return (
// 		<>
// 		</>
// 	);
// };
